module.exports = __webpack_public_path__ + "static/media/013-tooth.145c1057.svg";